module.exports = __webpack_public_path__ + "img/05.70eb2807.png";